/*global SunergoPlatform*/

/**
 * Initializes form submission processing, including pre-submission validation.
 * @param {object} form - a form item.
 */
const initFormSubmit = function(form) {
	// Setup disabling/enabling submit button.
	form.processing = {
		status: false,
		submitButtons: form.element.querySelectorAll('[data-form-submit]'),
		submitActionNote: form.element.querySelector('[data-action-note]')
	};

	const disableSavingDialog = form.element?.dataset?.disableSavingDialog == 'true';

	/**
	 * Set the processing status.
	 * @param {boolean} state - processing state
	 */
	form.processing.set = function(state) {
		form.processing.status = state;
		if (state === true) form.fieldFeedback.clear();

		this.submitButtons.forEach(function(button) {
			SunergoPlatform.actionButtons.setActive(button, form.processing.status);
		});

		if (!state && !disableSavingDialog) {
			const dialogSaving = SunergoPlatform.dialogs.get(`${form.name}_saving`);
			if (dialogSaving) dialogSaving.hide();
		}
	};

	let updatingNoteTimer = null;
	/**
	 * Set the submit action note.
	 * @param {string} note 
	 */
	form.processing.setNote = function(note) {
		if (updatingNoteTimer != null) clearTimeout(updatingNoteTimer);
		const element = this.submitActionNote;
		element.dataset.updating = true;
		updatingNoteTimer = setTimeout(function() {
			element.textContent = note;
			element.removeAttribute('data-updating');
		}, 50);
	};

	// Setup preSubmit array that will be used to run pre-submission tasks on submit.
	form.preSubmit = [];

	/**
	 * Run pre-submission tasks.
	 * @returns true when all pre-submission tasks have successfully completed.
	 */
	async function runPreSubmit() {
		for (const item of form.preSubmit) {
			if (await item()) continue;
			return false;
		}
		return true;
	}

	let dialogSavingTimer = null;
	
	/**
	 * Run tasks when form submitted.
	 * @param {object} event - event listener events
	 * @returns false when already processing.
	 */
	async function onSubmit(event) {
		// Prevent default submit.
		if (event) event.preventDefault();

		// If already processing, stop here.
		if (form.processing.status) return false;
		else form.processing.set(true);

		// Run pre-submission tasks.
		// If a pre-submission tasks return false, stop submission.
		if (!await runPreSubmit()) {
			// If the task returns false, it failed and we stop submission.
			form.processing.set(false);
			if (form.saveDialogConfirmed) form.saveDialogConfirmed = false;
			return;
		}

		// Use Remote Submit if enabled.
		// Otherwise, use nativeSubmit.
		const submit = form.element?.dataset?.customSubmit === 'true'
			? () => {}
			: form.remoteSubmit === undefined
			? form.nativeSubmit
			: form.remoteSubmit;


		// If asyncUpload for files is required, use uploader().
		if (!form.asyncUpload || (form.asyncUpload && form.asyncUpload.length < 1)) {
			if (disableSavingDialog === true) return submit();

			// If saving is taking longer than 10 seconds, show a dialog.
			const dialogSaving = SunergoPlatform.dialogs.get(`${form.name}_saving`);
			if (dialogSaving) {
				if (dialogSavingTimer !== null) clearTimeout(dialogSavingTimer);
				dialogSavingTimer = setTimeout(function() {
					if (form.processing.status) dialogSaving.show();
				}, 10 * 1000);
			}
			return submit();
		} 
		for (const uploader of form.asyncUpload) uploader(submit);
	}

	// Setup function to trigger form submission through scripts.
	form.submit = async function() {
		onSubmit();
	};
	form.nativeSubmit = function() {
		form.element.submit();
	};

	// Setup the listener for form submission.
	form.element.addEventListener(
		'submit',
		async function(event) {
			onSubmit(event);
		},
		false
	);
};

export default initFormSubmit;